<template>
  <div>
    <b
      v-if="item.contractPartnerName">
      {{item.contractPartnerName}}
    </b>
    <address
      v-if="item.id !== -1 && item.contractPartnerName !== 'Neuen Vertragspartner anlegen'">
      <!--TODO: Second condition is a crutch, but handles cases where the updateContractPartner sets the default cp with a wrong id -->
      <div>{{ item.street }} {{ item.streetNumber }}</div>
      <div>{{ item.postalCode + ', ' + item.city }}</div>
    </address>
  </div>
</template>

<script>
  export default {
    props: {
      item: {required: true}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contracts/ContractPartnerTemplate.vue